<!--
 * @Description: 页面级详情组件
 * @Author: cxh
 * @Date: 2022-09-16 11:25:08
 * @LastEditTime: 2022-11-25 10:29:35
 * @LastEditors: cxh
-->
<template>
  <div class="multiple-view-content">
    <template v-if="line">
      <div class="multiple-view-line" v-if="view"></div>
      <div class="multiple-edit-line" v-else></div>
    </template>
    <p v-else style="margin-top: 8px"></p>
    <div style="margin-left: -16px; margin-right: -16px">
      <a-col :span="24" :class="{ 'multiple-view': view }">
        <a-row :gutter="46">
          <slot></slot>
        </a-row>
      </a-col>
    </div>
  </div>
</template>
<script lang="ts" setup name="ViewMultipleItem">
defineProps({
  view: Boolean,
  line: {
    type: Boolean,
    default: true
  },
  span: {
    type: Number,
    default: 24
  }
})
</script>
<script lang="ts">
export default { name: 'MultipleItem' }
</script>
<style scoped lang="scss">
.multiple-edit-line {
  margin: 5px 8px 10px;
  border-top: 1px dashed #f3f3f9;
}
.multiple-view-content {
  margin-bottom: 16px;
  width: 100%;
  margin-left: 16px;
  margin-right: 16px;
  background: #f3f3f9;
}
.multiple-view-line {
  display: block;
  width: 100%;
  border-top: 1px dashed #d8dfe4;
}
.multiple-view {
  padding-top: 8px;
  :deep(.ant-form-item-control-input) {
    min-height: 20px;
  }
}
</style>
